import React, { useRef} from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
// import { useParams } from "react-router";
import { useCreateUserMutation } from "../../app/features/apiSlice";
import { toastError, toastSuccess } from "../../helpers";
import "react-phone-number-input/style.css";
import { Formik } from "formik";
import * as yup from "yup";
import { useGetUserBankDetailsQuery } from "../../app/features/apiSlice";

const BankDetails = ({ refetch }) => {
  const { t } = useTranslation();
  // const { lang } = useParams();
  const sessionId = useRef(Date.now()).current;

  const { data, error, isLoading } = useGetUserBankDetailsQuery({ sessionId });
  const accounDetails = data?.data

  const initialValues = {
    accountName: accounDetails?.account_name || "",
    accountNumber: accounDetails?.account_number || "",
    iban: accounDetails?.iban || "",
    swiftBic: accounDetails?.swift_bic || "",
  }

  const schema = yup.object().shape({
    accountName: yup.string().required("accountNameRequired"),
    accountNumber: yup.string().required("accountNumberRequired"),
    iban: yup.string().required("ibanRequired"),
    swiftBic: yup.string().required("swiftRequired"),
  });

  const [createUser] = useCreateUserMutation();

  const handleSubmit = async (values) => {
    console.log(values, "674");
    try {
      const response = await createUser({
        data: values,
      });
      if (response?.error) {
        toastError(response, t("error.serverNotResponding"));
      } else {
        const message = response?.data?.msg ?? response?.data?.message;
        toastSuccess(message);
        refetch();
      }
    } catch (err) {
      toastError(err, t("error.serverNotResponding"));
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading bank details</div>;
  }

  return (
    <Formik
      validationSchema={schema}
      onSubmit={(values) => handleSubmit(values)}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form noValidate onSubmit={handleSubmit} className="add-inner-form">
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              {t("payment.accountName")} *
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                name="accountName"
                placeholder={t("payment.accountName")}
                autoComplete="accountName"
                value={values.accountName}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.accountName && !!errors.accountName}
                size="sm"
              />
              <Form.Control.Feedback type="invalid">
                {t(`error.${errors.accountName}`)}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              {t("payment.accountNumber")} *
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                name="accountNumber"
                placeholder={t("payment.accountNumber")}
                autoComplete="accountNumber"
                value={values.accountNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.accountNumber && !!errors.accountNumber}
                size="sm"
              />
              <Form.Control.Feedback type="invalid">
                {t(`error.${errors.accountNumber}`)}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              {t("payment.IBAN")} *
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                name="iban"
                placeholder={t("payment.iban")}
                value={values.iban}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.iban && !!errors.iban}
                size="sm"
              />
              <Form.Control.Feedback type="invalid">
                {t(`error.${errors.iban}`)}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
              {t("payment.SWIFT/BIC")} *
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                name="swiftBic"
                placeholder={t("payment.SWIFT/BIC")}
                value={values.swiftBic}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={touched.swiftBic && !!errors.swiftBic}
                size="sm"
              />
              <Form.Control.Feedback type="invalid">
                {t(`error.${errors.swiftBic}`)}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Button variant="primary-outline" type="submit">
            {t("update")}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default BankDetails;
